
import { BaseResolver } from "@nx/typescript-domain";
import { ICalendarService } from "./calendars/ICalendarService";
import { ICardService } from "./cards/ICardService";
import { IExerciseService } from "./exercise/IExerciseService";

class Domain extends BaseResolver {
    public get calendarService() { return this.resolve<ICalendarService>("ICalendarService"); }
    public get cardService() { return this.resolve<ICardService>("ICardService"); }
    public get exerciseService() { return this.resolve<IExerciseService>("IExerciseService"); }

}
export const appDomain = new Domain();
